import actionCreator from '../../../utils/actionCreator';

const clientActionTypes = ['OPEN_MODAL', 'CLOSE_MODAL'];

export const { types: modalTypes, actions: modalActions } = actionCreator(clientActionTypes);
